import React, {useContext} from 'react';

const LoginContext = React.createContext();

export const useLoginContext = () => useContext(LoginContext);

export default LoginContext;
